import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
/**
 * Coordinates displaying of the spinner-overlay
 *
 * @export
 * @class SpinnerService
 */
var SpinnerService = /** @class */ (function () {
    function SpinnerService() {
        this._isStarted = false;
        this._behaviourSubject = new BehaviorSubject(false);
        this._queue = [];
    }
    Object.defineProperty(SpinnerService.prototype, "stream", {
        /**
         * Return the observeable which emits wether some work is in progress (true) or not (false)
         *
         * @readonly
         * @type {Observable<boolean>}
         * @memberof SpinnerService
         */
        get: function () {
            return this._behaviourSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Hand over a promis that must be fulfilled or rejected before removing the spinner
     *
     * @template T
     * @param {Promise<T>} promise
     * @memberof SpinnerService
     */
    SpinnerService.prototype.waitFor = function (promise) {
        this._queue.push(promise);
        if (!this._isStarted) {
            this.setState(true);
            this.run();
        }
    };
    /**
     * Run the loop in order to await all promises
     *
     * @private
     * @memberof SpinnerService
     */
    SpinnerService.prototype.run = function () {
        var _this = this;
        if (this._queue.length > 0) {
            this._queue.pop().then(function () { _this.run(); }, function () { _this.run(); });
        }
        else {
            this.setState(false);
        }
    };
    /**
     * Set {_isStarted} and emit value on {_behaviourSubject}
     *
     * @private
     * @param {boolean} state
     * @memberof SpinnerService
     */
    SpinnerService.prototype.setState = function (state) {
        this._isStarted = state;
        this._behaviourSubject.next(state);
    };
    SpinnerService.ngInjectableDef = i0.defineInjectable({ factory: function SpinnerService_Factory() { return new SpinnerService(); }, token: SpinnerService, providedIn: "root" });
    return SpinnerService;
}());
export { SpinnerService };
